export const MIXPANEL_EVENTS_MODEL = {
  MODEL_CREATE_FROM_UPLOAD_SCAN: 'model_create_from_upload_scan'
}
